module.exports = __webpack_public_path__ + "static/media/hollow_bar_AERO_hand.9b473598.svg";